import { linkToMonitoringOverviewPage } from "../../links";

export function linkToParentFeedback() {
  return `${linkToMonitoringOverviewPage()}/feedback`;
}
